import * as React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faMapMarkerAlt } from "@fortawesome/free-solid-svg-icons"

import Layout from "../../components/layout"
import SEO from "../../components/seo"
import Cover from '../../components/cover/cover'
import ContactForm from '../../components/form/form'

// image imports
import cover from "../../images/bangalore-cover.jpg"

const BangalorePage = () => (
  <Layout>
    <SEO title="Bangalore Chapter" />
    <Cover
      image={cover}
      title={`We Clothe Them, Bangalore`}
    />
    <section className={`sm`}>
      <div className={`content-sm`}>
        <h6 className={`letter-spaced-heading `}>Chapters &middot; Bangalore</h6>
        <h2 className={``}>About the Chapter</h2>
        <p className={``}>
        WCT Benagluru chapter, headed by Sarth, Suvansh and Akanksha was initiated in 2019. The Silicon Valley of India has seen distinguished collaborators in the face of MakeMyTrip and other corporate houses. Many home collection drives along with street distribution of clothes have been organized in the city.
        </p>
      </div>
    </section>
    <section className={`grey sm`}>
      <div className={`content-sm`}>
        <h2 className={``}>
          <span>
            <FontAwesomeIcon icon={faMapMarkerAlt} />
          </span>{" "}
          Reach Out
        </h2>
        <div className={`chapter-contact`}>
          <p>To join our Bengaluru family as a collaborator or volunteer and help us bring smiles on the faces of those in need:</p>
          <p>
            <b>Email:</b> bangalore@weclothethem.com
          </p>
          <p>
            <b>Contact:</b> +91-9999298196, +91-8700535580{" "}
          </p>
        </div>
      </div>
    </section>
    <section className={`sm`}>
      <div className={`content-sm`}>
        <h6 className={`letter-spaced-heading center`}>Contact</h6>
        <h2 className={`center`}>Write to Us</h2>
        <ContactForm />
      </div>
    </section>
  </Layout>
)

export default BangalorePage
